<template>
<smooth-scrollbar>
  <div style="height:65vh;">
    <group v-for="(vectors,key) in grouped_vectors" :key="key" :group="vectors" :name="key"></group>
  </div>
</smooth-scrollbar>
</template>
<script>
import { mapGetters } from "vuex";
import group from "./vector-group.component.vue";
import _ from "lodash";

export default {
  components: {
    group
  },
  computed: {
    ...mapGetters(["vectors"]),
    grouped_vectors() {
      return _.groupBy(this.vectors, "group");
    }
  }
};
</script>


